import ToolService from '@/providers/tools';
import EdYoutubeVideo from '@/content/pages/course-viewer/components/ed-youtube-video/ed-youtube-video.component.vue'
import EdTeacherMeetingTransparency from '@/core/components/ed-meeting-transparency/ed-teacher-meeting-transparency/ed-teacher-meeting-transparency.component.vue';
import EdStudentMeetingTransparency from '@/core/components/ed-meeting-transparency/ed-student-meeting-transparency/ed-student-meeting-transparency.component.vue';
import { SECTION_TYPE_CODES } from '@/core/values/ed-transparency-meeting.values';
import { _MEETINGS_STORE } from '@/meetings/values/meetings.values';
import { ScreenMirroringMixin } from '@/screen-mirroring/mixins/screen-mirroring.mixin';

export default {
  name: 'ed-video-viewer',
  components: {
    EdYoutubeVideo,
    EdTeacherMeetingTransparency,
    EdStudentMeetingTransparency
  },
  mixins: [ScreenMirroringMixin],
  props: {
    'section': {},
    'documentIndex': {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      pagesLoaded: false
    }
  },
  computed: {
    videoId() {
      let videoParams = null;
      if(this.section) {
        videoParams = this.section.text ? ToolService.getUrlParams(this.section.text) : videoParams;
      }
      return videoParams ? videoParams.v : null;
    },
    description() {
      return this.section ? this.section.description : '';
    },
    isPresentationTeacherMode() {
      return this.$store.state.CourseStore.isPresentationTeacherMode;
    },
    isWhiteboardTransparency() {
      return this.$store.state.MeetingsStore.isWhiteboardTransparency;
    },
    isPresentationStudentMode() {
      return this.$store.state.CourseStore.isPresentationStudentMode;
    },
    courseSelected() {
      return this.$store.state.CourseStore.presentationCourseSelected;
    },
    isSameCourse() {
      return this.courseSelected === this.section.courseId;
    },
    documentHash() {
      // desired length of Id
      var idStrLen = 32;
      // always start with a letter -- base 36 makes for a nice shortcut
      var idStr = (Math.floor((Math.random() * 25)) + 10).toString(36) + '_';
      // add a timestamp in milliseconds (base 36 again) as the base
      idStr += (new Date()).getTime().toString(36) + '_';
      // similar to above, complete the Id using random, alphanumeric characters
      do {
          idStr += (Math.floor((Math.random() * 35))).toString(36);
      } while (idStr.length < idStrLen);

      return (idStr);
    }
  },
  methods: {
    loadingPage() : void {
      if((document.querySelectorAll('.page-image')[0] as HTMLImageElement)?.offsetHeight == 0) {
        setTimeout(() => {
          this.loadingPage();
        }, 200);
      } else {
        const transparencyRef = this.$refs.teacherTransparency || this.$refs.studentTransparency;
        if(transparencyRef && !this.pagesLoaded) {
          let videoElement : any = document.querySelectorAll('.page-image')[0];
          let data = { height: videoElement.offsetHeight, width: videoElement.offsetWidth, sectionType: SECTION_TYPE_CODES.LESSON_VIDEO, page: 1 };
          transparencyRef.loadingPage(data);
          this.$store.commit( _MEETINGS_STORE.MUTATIONS.UPDATE_ORIGINAL_PAGES_SIZE ,{ documentHash: this.documentHash, pageNumber: 1, data});
          this.pagesLoaded = true;
          this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_LOADED_BOARDS_IN_DOM, 0);
        }
      }
    }
  },
  mounted() {
    this.loadingPage();
    window.addEventListener('resize', this.onResize);
  },
  updated() {
    this.loadingPage();
  }
};
